import { useState } from 'react';
import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import Accordion from 'components/library/Accordion/accordion';
import { ExpandCircleDown } from 'lib/svgs/expand-circle-down';
import { richTextToHtml } from 'lib/pdp-modules/helpers';
import type { FaqModule } from 'lib/pdp-modules/types';

const FAQWrapper = styled.div`
  margin: auto;
  max-width: 1440px;
  padding: 4rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media ${mqLargeMin} {
    padding: 6rem 3rem;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 350;
  line-height: 40px;
  color: var(--fill-brand);

  @media ${mqLargeMin} {
    font-size: 48px;
    line-height: 56px;
    letter-spacing: -0.48px;
  }
`;

const AccordionWrapper = styled.div`
  max-width: 41.25rem;
  width: 100%;
`;

const DisplayAllButton = styled.button`
  display: inline-flex;
  margin-top: 1rem;
  border: 0;
  align-items: center;
  gap: 0.5rem;
  background-color: transparent;
  appearance: none;

  path {
    fill: currentColor;
  }
`;

const SectionCurious = ({ faqModule }: { faqModule?: FaqModule }) => {
  if (!faqModule?.items?.length) {
    return null;
  }

  const [displayAll, setDisplayAll] = useState(false);

  const numberToDisplay = displayAll ? faqModule.items.length : 3;
  const accordionContent = faqModule.items
    .map((faq) => {
      return {
        title: faq.question,
        content: richTextToHtml(faq.answer, { newLineToBreak: true }),
        accordionEvent: {
          buttonName: 'FAQ',
          question: faq.question,
          location: 'PDP',
        },
      };
    })
    .slice(0, numberToDisplay);

  return (
    <FAQWrapper>
      <Title>
        Questions?
        <br />
        We're here to help.
      </Title>
      <AccordionWrapper>
        <Accordion items={accordionContent} displayContentAsHTML={true} />
        {!displayAll && faqModule.items.length > 3 && (
          <DisplayAllButton onClick={() => setDisplayAll(true)}>
            <ExpandCircleDown />
            View All
          </DisplayAllButton>
        )}
      </AccordionWrapper>
    </FAQWrapper>
  );
};

export default SectionCurious;
